module.exports = require("@fluent/syntax");